import PropTypes from 'prop-types';
import { ThemedComponent } from 'ui/theme';
import { theme } from 'ui/theme-color';
import { ColorButton, GradientButton, Load, Mbutton } from './styled';

export const Button = ({
  children,
  loading,
  color = 'white',
  outline,
  link,
  nospace,
  centred,
  onClick,
  startIcon,
  endIcon,
  border,
  width,
  small,
  gradient,
  disabled,
  mbutton,
  fontSize,
  style,
}) => {
  const safeColor = theme.palette?.[color] ? color : 'primary';
  let GButton = gradient ? GradientButton : ColorButton;
  if (mbutton) {
    GButton = Mbutton;
  }

  return (
    <>
      <ThemedComponent>
        <GButton
          variant={link ? 'text' : outline ? 'outlined' : 'contained'}
          color={safeColor}
          nospace={nospace}
          centred={centred}
          onClick={onClick}
          outline={outline}
          startIcon={startIcon}
          endIcon={endIcon}
          small={small}
          disabled={disabled}
          border={border}
          width={width}
          fontSize={fontSize}
          style={style}
        >
          {loading ? (
            <Load color={safeColor} outline={outline} />
          ) : (
            <>{children}</>
          )}
        </GButton>
      </ThemedComponent>
    </>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  outline: PropTypes.bool,
  link: PropTypes.bool,
  nospace: PropTypes.bool,
  centred: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  children: undefined,
  color: 'white',
  outline: false,
  link: false,
  nospace: false,
  disabled: false,
  centred: false,
  loading: false,
  onClick: undefined,
};

export default Button;
